var _path, _path2, _g, _rect, _path3, _path4, _rect2, _rect3, _rect4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularity({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 104,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0228 7.78535C42.3036 6.46852 45.1137 6.46852 47.3945 7.78535L76.7314 24.723C79.0122 26.0398 80.4172 28.4734 80.4172 31.1071V64.9824C80.4172 67.6161 79.0122 70.0497 76.7314 71.3665L47.3945 88.3042C45.1137 89.621 42.3036 89.621 40.0227 88.3042L10.6859 71.3665C8.40504 70.0497 7 67.6161 7 64.9824V31.1071C7 28.4734 8.40504 26.0398 10.6859 24.723L40.0228 7.78535Z",
    fill: "#CDF5E3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9195_19606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 12,
    width: 65,
    height: 72
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#8D61E8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9195_19606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.864 12.9152C42.7172 11.8453 45.0004 11.8453 46.8535 12.9152L72.7845 27.8865C74.6377 28.9564 75.7793 30.9337 75.7793 33.0736V63.0161C75.7793 65.156 74.6377 67.1333 72.7845 68.2032L46.8535 83.1745C45.0004 84.2444 42.7172 84.2444 40.864 83.1745L14.933 68.2032C13.0798 67.1333 11.9382 65.156 11.9382 63.0161V33.0736C11.9382 30.9337 13.0798 28.9564 14.933 27.8865L40.864 12.9152Z",
    fill: "#40D594"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.846 45.06C72.2298 83.5011 12.5546 43.3756 6.58582 9.86806L-27.8162 57.6638L55.5728 117.685L107.846 45.06Z",
    fill: "#169771"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 21.05,
    width: 49.725,
    height: 48.45,
    rx: 6.8,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2002 58.8751C54.2002 56.9973 55.7224 55.4751 57.6002 55.4751H68.2252V62.7001C68.2252 66.4556 65.1807 69.5001 61.4252 69.5001H54.2002V58.8751Z",
    fill: "#CEE3EC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 27.85C18.5 24.0945 21.5445 21.05 25.3 21.05H61.425C65.1805 21.05 68.225 24.0945 68.225 27.85V33.8H18.5V27.85Z",
    fill: "#37B1E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28.7002,
    y: 18.5,
    width: 3.825,
    height: 10.2,
    rx: 1.9125,
    fill: "#666A6F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.4502,
    y: 18.5,
    width: 3.825,
    height: 10.2,
    rx: 1.9125,
    fill: "#666A6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 54.2002,
    y: 18.5,
    width: 3.825,
    height: 10.2,
    rx: 1.9125,
    fill: "#666A6F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3316 43.5745L40.8241 52.5314L37.3854 48.9043L37.3854 48.9042L37.3811 48.8999C37.238 48.7545 37.0682 48.6394 36.8809 48.5618C36.6936 48.4842 36.4931 48.4459 36.2908 48.4496C36.0886 48.4533 35.8895 48.4988 35.705 48.5831C35.5206 48.6674 35.3548 48.7885 35.2167 48.9388C35.0787 49.0891 34.9709 49.2656 34.8989 49.4578C34.8268 49.6501 34.7916 49.855 34.795 50.0608C34.7984 50.2666 34.8403 50.4701 34.9187 50.6598C34.9967 50.8486 35.1096 51.0205 35.2517 51.1654L39.7554 55.9006C39.7556 55.9008 39.7558 55.901 39.756 55.9011C39.8942 56.0476 40.0595 56.1647 40.2428 56.245C40.4264 56.3254 40.624 56.3671 40.8239 56.3671C41.0238 56.3671 41.2214 56.3254 41.405 56.245C41.5883 56.1647 41.7536 56.0475 41.8919 55.9011C41.8921 55.9009 41.8922 55.9008 41.8924 55.9006L51.4634 45.8375C51.6124 45.6917 51.7304 45.5164 51.8111 45.3227C51.8926 45.1269 51.9345 44.916 51.9345 44.7033C51.9345 44.4905 51.8926 44.2797 51.8111 44.0839C51.7304 43.8903 51.6125 43.715 51.4636 43.5693C51.3263 43.425 51.1626 43.3095 50.9812 43.2301C50.7976 43.1497 50.6 43.108 50.4001 43.108C50.2002 43.108 50.0026 43.1497 49.819 43.2301C49.6357 43.3104 49.4703 43.4276 49.3321 43.574C49.3319 43.5742 49.3318 43.5743 49.3316 43.5745Z",
    fill: "#2AC682",
    stroke: "#2AC682",
    strokeWidth: 0.646783
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularity);
export default __webpack_public_path__ + "static/media/regularity.dde30d8adb5ba8c8c3049c87b6ee9a1d.svg";
export { ForwardRef as ReactComponent };